export const adaptForm = (claimsData) => {
  const { forms } = claimsData

  const staticTypeMap = {
    claim_amount: 'claim_amount',
    nik_number: 'nik_number',
    disclaimer_aus: 'disclaimer_aus'
  }

  const adaptedForms = forms.map((form) => ({
    ...form,
    attributes: form.attributes.map((attr) => ({
      ...attr,
      type: staticTypeMap[attr.name] || attr.type
    }))
  }))

  return {
    ...claimsData,
    forms: adaptedForms
  }
}
